import React from "react"

const TextWithIcon = ({
  Icon,
  text = "",
  onclick = () => { },
  className = "",
}) => {
  return (
    <div
      className={`inline-flex justify-center items-center text-primary font-Apparat font-[600] md:font-[700] text-[10px] md:text-[18px] leading-[11.5px] md:leading-[30px] tracking-[-2%] underline ${className}`}
      onClick={onclick}
    >
      <div className="inline-flex justify-center items-center">
        {Icon && <Icon />}
        <span className="ml-[5px]">{text}</span>
      </div>
    </div>
  )
}

export default TextWithIcon
